import { Link } from '@tiptap/extension-link';
import TextAlign from '@tiptap/extension-text-align';
import Underline from '@tiptap/extension-underline';
import { generateHTML } from '@tiptap/react';
import StarterKit from '@tiptap/starter-kit';
import cx from 'classnames';
import { useEffect, useState } from 'react';
import css from './RichTextDisplay.module.scss';

export interface IRichTextDisplayProps {
  className?: string;
  html?: string;
  json?: string;
}

export const RichTextDisplay = ({
  className,
  html: passedHtml,
  json,
}: IRichTextDisplayProps) => {
  const [html, setHtml] = useState<string>(passedHtml);

  useEffect(() => {
    if (json) {
      setHtml(
        generateHTML(JSON.parse(json), [
          StarterKit,
          Link,
          TextAlign.configure({
            types: ['paragraph', 'heading'],
            alignments: ['left', 'center', 'right'],
            defaultAlignment: 'left',
          }),
          Underline,
        ])
      );
    } else {
      setHtml(passedHtml);
    }
  }, [json, passedHtml]);

  return (
    <div
      className={cx(css.richTextDisplay, className)}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};
